import type { ReactNode } from 'react';

export const symbol_account_tree: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M604-180v-65h-94q-24.75 0-42.37-17.63Q450-280.25 450-305v-350h-93v70q0 24.75-17.62 42.37Q321.75-525 297-525H140q-24.75 0-42.37-17.63Q80-560.25 80-585v-195q0-24.75 17.63-42.38Q115.25-840 140-840h157q24.75 0 42.38 17.62Q357-804.75 357-780v65h247v-65q0-24.75 17.63-42.38Q639.25-840 664-840h156q24.75 0 42.38 17.62Q880-804.75 880-780v195q0 24.75-17.62 42.37Q844.75-525 820-525H664q-24.75 0-42.37-17.63Q604-560.25 604-585v-70h-94v350h94v-70q0-24.75 17.63-42.38Q639.25-435 664-435h156q24.75 0 42.38 17.62Q880-399.75 880-375v195q0 24.75-17.62 42.37Q844.75-120 820-120H664q-24.75 0-42.37-17.63Q604-155.25 604-180ZM140-780v195-195Zm524 405v195-195Zm0-405v195-195Zm0 195h156v-195H664v195Zm0 405h156v-195H664v195ZM140-585h157v-195H140v195Z"
		/>
	</svg>
);
